import { render, staticRenderFns } from "./MedicaoSilo.vue?vue&type=template&id=2ad6fc80&scoped=true"
import script from "./MedicaoSilo.vue?vue&type=script&lang=js"
export * from "./MedicaoSilo.vue?vue&type=script&lang=js"
import style0 from "./MedicaoSilo.vue?vue&type=style&index=0&id=2ad6fc80&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ad6fc80",
  null
  
)

export default component.exports